import React from 'react';
import PropTypes from 'prop-types';

const CleanButton = ({ children, style, ...props }) => {
  return (
    <button {...props} style={{ border: 'none', background: 'transparent', padding: 0, ...style }}>{children}</button>
  );
}


CleanButton.propTypes = {
  children: PropTypes.node.isRequired,
  style: PropTypes.object
};

CleanButton.defaultProps = {
  style: {}
};

export default CleanButton;
